const blockTransitionDurationMs = 250;

// Responsible for rendering gradients indicating that scrolling can be
// performed in both directions
const scrollWrapperCls = "c2lsh39oee";
const scrollContainerCls = "c2ls1e8h26j";
const listCls = "c2ll1wx47t7";
const transitionableBlockCls = "c2ltnhhtil";

export { blockTransitionDurationMs, listCls, scrollContainerCls, scrollWrapperCls, transitionableBlockCls };
import "./block-list.style.linaria.module.css";
//# sourceMappingURL=block-list.style.js.map
